import { Button, styled } from "@mui/material";

const StyledButtonSecondaryMini = styled(Button)(({ theme }) => ({
  paddingRight: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  backgroundColor: theme.palette.common.white,
  color: theme.palette.info.main,
  "&:hover": {
    backgroundColor: theme.palette.common.white,
  },
  border: `1px solid ${theme.palette.info.main}`,
  boxShadow: "none",
  "&:disabled": {
    border: "none",
  },
})) as typeof Button;

export default StyledButtonSecondaryMini;
